function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyStateWeldPhoto = function SvgEmptyStateWeldPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.088,
    height: 86.616
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4234"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.038 67.521c-.166-9.055 1.839-17.572-.664-26.558C117.48 23.461 99.01 13.7 82.143 21.207a29.3 29.3 0 0 0-5.53 3.235q-1.106.581-2.157 1.2C68.843 28.921 62.829 34.2 56.691 36c-7.811 2.295-16.2 2.834-24.1 5.032C16.888 45.4 1.446 58 6.478 76.286c5.53 20 29.24 20.572 45.25 15.3 6.166-2.032 11.765-2.765 17.973-.484 5.876 2.171 11.2 5.959 16.908 8.627 6.913 3.194 14.074 5.641 21.761 5.53 11.24-.152 20.434-8.447 20.116-19.922-.153-6.756-5.337-11.277-5.448-17.816",
    style: {
      fill: "#f0f6fa"
    },
    transform: "translate(-5.509 -18.651)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.783 3.548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.849 4.115H0V3.056h2.849V0h1.114v3.056h2.85v1.059h-2.85v3.056H2.849z",
    style: {
      fill: "#f0f6fa"
    },
    transform: "translate(119.425 26.674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.414 3.617H0v-.94h2.414V0h.945v2.677h2.417v.932H3.357v2.677h-.945z",
    "data-name": "Path",
    style: {
      fill: "#f0f6fa"
    },
    transform: "translate(0 33.201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.318 4.778H0v-1.23h3.311V0h1.3v3.548h3.314v1.23h-3.31v3.548H3.323z",
    "data-name": "Path",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(129.38 22.233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49 3.476H0v-.9h2.49V0h.974v2.578h2.482v.9H3.463v2.576H2.49z",
    "data-name": "Path",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(4.276 20.21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.414 3.476H0v-.9h2.414V0h.945v2.578h2.415v.9H3.357v2.576h-.945z",
    "data-name": "Path",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(127.384 37.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.458,
    height: 7.633,
    rx: 2.729,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-79 32.376 -29.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.106,
    height: 31.626,
    rx: 6.553,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-79 41.408 -34.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.922a6 6 0 0 1 6 6v17.444a6 6 0 0 1-6 6H0z",
    style: {
      fill: "#f0f6fa"
    },
    transform: "rotate(-79 41.523 -35.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.679,
    height: 69.8,
    rx: 9.11,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-79 48.607 -1.341)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.495,
    height: 67.619,
    rx: 8,
    style: {
      fill: "#f0f6fa"
    },
    transform: "rotate(-79 48.722 -2.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0h8.753a6 6 0 0 1 6 6v55.614a6 6 0 0 1-6 6H2a2 2 0 0 1-2-2V6a6 6 0 0 1 6-6",
    style: {
      fill: "rgba(174,206,224,.6)"
    },
    transform: "rotate(-79 38.352 -15.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.014 0H1.1l-.01 67.61H0z",
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-79 38.355 -15.132)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.82,
    cy: 15.82,
    r: 15.82,
    style: {
      fill: "#aecee0"
    },
    transform: "translate(63.992 15.483)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.797,
    cy: 3.797,
    r: 3.797,
    style: {
      fill: "#aecee0"
    },
    transform: "translate(104.49 18.858)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.765,
    cy: 14.765,
    r: 14.765,
    style: {
      fill: "#fff"
    },
    transform: "translate(64.836 16.749)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.742,
    cy: 2.742,
    r: 2.742,
    style: {
      fill: "#fff"
    },
    transform: "translate(105.334 19.702)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.281,
    cy: 9.281,
    r: 9.281,
    style: {
      fill: "#aecee0"
    },
    transform: "translate(70.32 22.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.226,
    cy: 8.226,
    r: 8.226,
    style: {
      fill: "#f0f6fa"
    },
    transform: "translate(71.585 23.076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.741.113C7.561.866 9.964 5.1 9.108 9.562a9.15 9.15 0 0 1-2.113 4.359 11 11 0 0 0 .531-1.873C8.553 6.688 5.576 1.594.873.668A8 8 0 0 0 0 .547 6.24 6.24 0 0 1 3.741.113",
    style: {
      fill: "#fff"
    },
    transform: "translate(77.491 24.342)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.531,
    height: 50.219,
    rx: 4.55,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-5.13 257.205 -129.209)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.35,
    height: 48.036,
    rx: 4.55,
    style: {
      fill: "#fff"
    },
    transform: "rotate(-5.13 269.194 -142.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.987,
    height: 33.843,
    rx: 4.55,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-5.13 293.22 -168.277)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.943,
    height: 31.788,
    rx: 4.55,
    style: {
      fill: "#fff"
    },
    transform: "rotate(-5.143 292.363 -174.104)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.27,
    cy: 3.274,
    rx: 3.27,
    ry: 3.274,
    style: {
      fill: "#aecee0"
    },
    transform: "rotate(-.27 6083.624 -4169.546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.534 6.6 8.2l6.986 2.612L25.477 0l7.736 4.219 1.379 15.636L.9 22.78z",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(18.853 34.467)"
  }))));
};
export { SvgEmptyStateWeldPhoto as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDEuMDg4IiBoZWlnaHQ9Ijg2LjYxNiIgdmlld0JveD0iMCAwIDE0MS4wODggODYuNjE2Ij4KICAgIDxnIGRhdGEtbmFtZT0iR3JvdXAgNDIzNCI+CiAgICAgICAgPHBhdGggZD0iTTEyMy4wMzggNjcuNTIxYy0uMTY2LTkuMDU1IDEuODM5LTE3LjU3Mi0uNjY0LTI2LjU1OEMxMTcuNDggMjMuNDYxIDk5LjAxIDEzLjcgODIuMTQzIDIxLjIwN2EyOS4yNjcgMjkuMjY3IDAgMCAwLTUuNTMgMy4yMzVxLTEuMTA2LjU4MS0yLjE1NyAxLjJDNjguODQzIDI4LjkyMSA2Mi44MjkgMzQuMiA1Ni42OTEgMzZjLTcuODExIDIuMjk1LTE2LjIgMi44MzQtMjQuMSA1LjAzMkMxNi44ODggNDUuNCAxLjQ0NiA1OCA2LjQ3OCA3Ni4yODZjNS41MyAyMCAyOS4yNCAyMC41NzIgNDUuMjUgMTUuMyA2LjE2Ni0yLjAzMiAxMS43NjUtMi43NjUgMTcuOTczLS40ODQgNS44NzYgMi4xNzEgMTEuMiA1Ljk1OSAxNi45MDggOC42MjcgNi45MTMgMy4xOTQgMTQuMDc0IDUuNjQxIDIxLjc2MSA1LjUzIDExLjI0LS4xNTIgMjAuNDM0LTguNDQ3IDIwLjExNi0xOS45MjItLjE1My02Ljc1Ni01LjMzNy0xMS4yNzctNS40NDgtMTcuODE2eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUuNTA5IC0xOC42NTEpIiBzdHlsZT0iZmlsbDojZjBmNmZhIi8+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy43ODMgMy41NDgpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTIuODQ5IDQuMTE1SDBWMy4wNTZoMi44NDlWMGgxLjExNHYzLjA1NmgyLjg1djEuMDU5aC0yLjg1djMuMDU2SDIuODQ5eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE5LjQyNSAyNi42NzQpIiBzdHlsZT0iZmlsbDojZjBmNmZhIi8+CiAgICAgICAgICAgIDxwYXRoIGRhdGEtbmFtZT0iUGF0aCIgZD0iTTIuNDE0IDMuNjE3SDB2LS45NGgyLjQxNFYwaC45NDV2Mi42NzdoMi40MTd2LjkzMkgzLjM1N3YyLjY3N2gtLjk0NXoiIHN0eWxlPSJmaWxsOiNmMGY2ZmEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzMuMjAxKSIvPgogICAgICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlBhdGgiIGQ9Ik0zLjMxOCA0Ljc3OEgwdi0xLjIzaDMuMzExVjBoMS4zdjMuNTQ4aDMuMzE0djEuMjNoLTMuMzF2My41NDhIMy4zMjN6IiBzdHlsZT0iZmlsbDojYWVjZWUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjkuMzggMjIuMjMzKSIvPgogICAgICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlBhdGgiIGQ9Ik0yLjQ5IDMuNDc2SDB2LS45aDIuNDlWMGguOTc0djIuNTc4aDIuNDgydi45SDMuNDYzdjIuNTc2SDIuNDl6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjI3NiAyMC4yMSkiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJQYXRoIiBkPSJNMi40MTQgMy40NzZIMHYtLjloMi40MTRWMGguOTQ1djIuNTc4aDIuNDE1di45SDMuMzU3djIuNTc2aC0uOTQ1eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI3LjM4NCAzNy45KSIgc3R5bGU9ImZpbGw6I2FlY2VlMCIvPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iNS40NTgiIGhlaWdodD0iNy42MzMiIHJ4PSIyLjcyOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTc5IDMyLjM3NiAtMjkuMTIpIiBzdHlsZT0iZmlsbDojYWVjZWUwIi8+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxMy4xMDYiIGhlaWdodD0iMzEuNjI2IiByeD0iNi41NTMiIHRyYW5zZm9ybT0icm90YXRlKC03OSA0MS40MDggLTM0LjMzMykiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTAgMGg0LjkyMmE2IDYgMCAwIDEgNiA2djE3LjQ0NGE2IDYgMCAwIDEtNiA2SDBWMHoiIHRyYW5zZm9ybT0icm90YXRlKC03OSA0MS41MjMgLTM1LjU0KSIgc3R5bGU9ImZpbGw6I2YwZjZmYSIvPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iNDMuNjc5IiBoZWlnaHQ9IjY5LjgiIHJ4PSI5LjExIiB0cmFuc2Zvcm09InJvdGF0ZSgtNzkgNDguNjA3IC0xLjM0MSkiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjQxLjQ5NSIgaGVpZ2h0PSI2Ny42MTkiIHJ4PSI4IiB0cmFuc2Zvcm09InJvdGF0ZSgtNzkgNDguNzIyIC0yLjU1KSIgc3R5bGU9ImZpbGw6I2YwZjZmYSIvPgogICAgICAgICAgICA8cGF0aCBkPSJNNiAwaDguNzUzYTYgNiAwIDAgMSA2IDZ2NTUuNjE0YTYgNiAwIDAgMS02IDZIMmEyIDIgMCAwIDEtMi0yVjZhNiA2IDAgMCAxIDYtNnoiIHRyYW5zZm9ybT0icm90YXRlKC03OSAzOC4zNTIgLTE1LjEzKSIgc3R5bGU9ImZpbGw6cmdiYSgxNzQsMjA2LDIyNCwuNikiLz4KICAgICAgICAgICAgPHBhdGggZD0iTS4wMTQgMEgxLjFsLS4wMSA2Ny42MUgweiIgdHJhbnNmb3JtPSJyb3RhdGUoLTc5IDM4LjM1NSAtMTUuMTMyKSIgc3R5bGU9ImZpbGw6I2FlY2VlMCIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxNS44MiIgY3k9IjE1LjgyIiByPSIxNS44MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjMuOTkyIDE1LjQ4MykiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMy43OTciIGN5PSIzLjc5NyIgcj0iMy43OTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNC40OSAxOC44NTgpIiBzdHlsZT0iZmlsbDojYWVjZWUwIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjE0Ljc2NSIgY3k9IjE0Ljc2NSIgcj0iMTQuNzY1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NC44MzYgMTYuNzQ5KSIgc3R5bGU9ImZpbGw6I2ZmZiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIyLjc0MiIgY3k9IjIuNzQyIiByPSIyLjc0MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA1LjMzNCAxOS43MDIpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjkuMjgxIiBjeT0iOS4yODEiIHI9IjkuMjgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MC4zMiAyMi4yMzMpIiBzdHlsZT0iZmlsbDojYWVjZWUwIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjguMjI2IiBjeT0iOC4yMjYiIHI9IjguMjI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MS41ODUgMjMuMDc2KSIgc3R5bGU9ImZpbGw6I2YwZjZmYSIvPgogICAgICAgICAgICA8cGF0aCBkPSJNMy43NDEuMTEzQzcuNTYxLjg2NiA5Ljk2NCA1LjEgOS4xMDggOS41NjJhOS4xNTQgOS4xNTQgMCAwIDEtMi4xMTMgNC4zNTkgMTEuMTQ2IDExLjE0NiAwIDAgMCAuNTMxLTEuODczQzguNTUzIDYuNjg4IDUuNTc2IDEuNTk0Ljg3My42NjhBNy43NTggNy43NTggMCAwIDAgMCAuNTQ3IDYuMjQ0IDYuMjQ0IDAgMCAxIDMuNzQxLjExM3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc3LjQ5MSAyNC4zNDIpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSI0Mi41MzEiIGhlaWdodD0iNTAuMjE5IiByeD0iNC41NSIgdHJhbnNmb3JtPSJyb3RhdGUoLTUuMTMgMjU3LjIwNSAtMTI5LjIwOSkiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjQwLjM1IiBoZWlnaHQ9IjQ4LjAzNiIgcng9IjQuNTUiIHRyYW5zZm9ybT0icm90YXRlKC01LjEzIDI2OS4xOTQgLTE0Mi4yMjEpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIzNS45ODciIGhlaWdodD0iMzMuODQzIiByeD0iNC41NSIgdHJhbnNmb3JtPSJyb3RhdGUoLTUuMTMgMjkzLjIyIC0xNjguMjc3KSIgc3R5bGU9ImZpbGw6I2FlY2VlMCIvPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iMzMuOTQzIiBoZWlnaHQ9IjMxLjc4OCIgcng9IjQuNTUiIHRyYW5zZm9ybT0icm90YXRlKC01LjE0MyAyOTIuMzYzIC0xNzQuMTA0KSIgc3R5bGU9ImZpbGw6I2ZmZiIvPgogICAgICAgICAgICA8ZWxsaXBzZSBjeD0iMy4yNyIgY3k9IjMuMjc0IiByeD0iMy4yNyIgcnk9IjMuMjc0IiB0cmFuc2Zvcm09InJvdGF0ZSgtLjI3IDYwODMuNjI0IC00MTY5LjU0NikiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTAgMTIuNTM0IDYuNiA4LjJsNi45ODYgMi42MTJMMjUuNDc3IDBsNy43MzYgNC4yMTkgMS4zNzkgMTUuNjM2TC45IDIyLjc4IDAgMTIuNTM0eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTguODUzIDM0LjQ2NykiIHN0eWxlPSJmaWxsOiNhZWNlZTAiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";